import { injectIntl } from 'react-intl';

import WorkTypeFilter from './WorkTypeFilter';

export default injectIntl(WorkTypeFilter);
